import socket from './socket';

const getListReportData = (listId, headers) =>
  socket.get(`/lists/${listId}/list-report-data`, undefined, headers);

const upsertListReportData = (listId, data, headers) =>
  socket.post(`/lists/${listId}/list-report-data`, data, headers);

const completeListReportData = (listId, headers) =>
  socket.post(`/lists/${listId}/list-report-data/complete`, undefined, headers);

const updateListReportEmployeeLevels = (listId, data, headers) =>
  socket.patch(`/lists/${listId}/list-report-data/employee-levels`, data, headers);

export default {
  getListReportData,
  upsertListReportData,
  completeListReportData,
  updateListReportEmployeeLevels,
};
